import {pageUrlMap} from '@jobseeker/common-core/constants';
import {EventProps, gaTrackCustomEvent} from './gtag';
import ubaEventLogger from './ubaEventLogger';

export interface TrackingEvent extends EventProps {}

export const InitiateUBA = (pageName: string) => {
  pageName &&
    (window as any)?.tracking &&
    (window as any)?.tracking.init(
      {
        appId: process.env.NEXT_PUBLIC_UBA_APP_ID,
      },
      {
        pageName: pageName,
      }
    );
};

const validateSessionUsername = (raw: unknown): string => {
  if (raw == null) return '';
  if (typeof raw === 'number') {
    return raw > 0 ? String(raw) : '';
  }
  if (typeof raw === 'string') {
    const parsed = Number(raw);
    if (!isNaN(parsed) && parsed > 0) {
      return String(parsed);
    }
  }
  return '';
};

export const TrackEventUBA = (
  eventName: string,
  actionType: string,
  obj: Record<string, unknown>
) => {
  console.log('TrackEventUBA', 'TrackingEvent', 'beforeDoTracking', {
    eventName,
    tracking: (window as any)?.tracking,
  });
  if (typeof window === 'undefined') return;
  if (!(window as any)?.tracking) return;
  const keyNamesObject = {
    actionSrc: 'normal',
    actionType,
    ref: new URL(window.location.href).searchParams.get('ref') || '',
    ...obj,
    sessionUsername:
      validateSessionUsername(sessionStorage.getItem('userId')) ||
      validateSessionUsername(obj.sessionUsername) ||
      '',
  };
  (window as any)?.tracking.doTracking({
    uba: {eventName, keyNames: keyNamesObject},
  });
  if (process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs') {
    setTimeout(() => {
      try {
        ubaEventLogger.logEvent(eventName, keyNamesObject);
      } catch (e) {
        console.log('UBA Logger Error', e);
      }
    }, 0);
  }
  console.log('TrackingEvent', {
    eventName,
    keyNamesObject,
    trackingObj: (window as any)?.tracking,
    doTrackingObj: (window as any)?.tracking.doTracking,
  });
};

export const handleTracking = (
  action: string,
  tracking: Partial<TrackingEvent>,
  actiontype?: string,
  isUba: boolean = false
) => {
  if (typeof window === 'undefined') return;
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
  gaTrackCustomEvent(isAppIimjobs ? action : `${action}New`, tracking);
  if (isUba) {
    TrackEventUBA(action, actiontype || '', tracking);
  }
};

export const getUbaPageName = () => {
  if (typeof window === 'undefined') return '';

  const path = window.location.pathname || '';

  if (path === '') return '';

  let pageName = '';
  if (path === '/') {
    pageName = 'Home Page';
  } else {
    Object.entries(pageUrlMap).map(([key]) => {
      if (path.includes(key)) {
        pageName = pageUrlMap[key];
      }
    });
  }
  return pageName;
};
